export const RECAPTCHA_ACTION = {
  SYNTHESIS: 'synthesis',
};

export const RECAPTCHA_TYPE = {
  V3: 'V3',
  ENTERPRISE: 'ENTERPRISE',
};
